import { SERVICE_GROUP_ID } from '@/constants';
import { ServiceGroup } from '@/types/serviceGroup';
import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

type Props = {
  serviceGroupId: ServiceGroup['id'];
};

export const ServiceEndingAndStartAnnouncement: React.FC<Props> = (props) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  /**
   * 指定の日付以前と以後で表示する内容を切り替える
   * FIXME: 2025年7月31日以降の条件分岐を削除する
   * @returns {string} i18nキー
   */
  const toHodaiPlusEndingAndStartAnnouncement = () => {
    if (new Date() < new Date('2025-07-31T00:00:00+09:00')) {
      return 'ui.subscription.toHodaiPlusEndingAndStartAnnouncement';
    } else {
      return 'ui.subscription.toHodaiPlusWithout12MonthEndingAndStartAnnouncement';
    }
  };

  return (
    <>
      {props.serviceGroupId === SERVICE_GROUP_ID.emba && (
        <Announcement>
          <Trans i18nKey="ui.subscription.toEmbaEndingAndStartAnnouncement"></Trans>
        </Announcement>
      )}
      {props.serviceGroupId === SERVICE_GROUP_ID.hodaiplus && (
        <Announcement>
          <Trans i18nKey={toHodaiPlusEndingAndStartAnnouncement()}>
            <a
              href={`${baseUrl}/services/9`}
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </Trans>
        </Announcement>
      )}
    </>
  );
};

const Announcement = styled.div`
  color: red;
  font-size: 14px;
  border: 1px;
  margin-bottom: 20px;
`;
